import { clearApiClient } from './clearApiClient';
import { type ProfileAPIResponse, profileReponseSchema } from './schema/profileSchema';
import { logSchemaMismatchError } from './schema/schemaUtils';

export const fetchProfile = () =>
  clearApiClient.get<ProfileAPIResponse>('/web/v1/profile?include_payment_data=false').then((response) => {
    const parseResult = profileReponseSchema.safeParse(response.data);

    if (!parseResult.success) {
      logSchemaMismatchError(parseResult.error, 'Profile schema mismatch');

      return response.data; // we ball, anyways
    }

    return parseResult.data;
  });
